import{AnimationFeature as i}from"./animation/index.mjs.js";import{ExitAnimationFeature as t}from"./animation/exit.mjs.js";const m={animation:{Feature:i},exit:{Feature:t}};export{m as animations};
